(ns web3.icons.shapes)

(def chevron-left [:svg
                   {:width "9px", :height "16px", :view-box "1 0 9 16", :preserve-aspect-ratio "xMidYMid meet"}
                   [:defs {}]
                   [:g
                    {:stroke "none", :stroke-width "1", :fill "none", :fill-rule "evenodd"}
                    [:g
                     {:transform "translate(2.000000, 1.000000)", :stroke-width "2", :stroke "currentColor"}
                     [:polyline {:points "6 -1.59872116e-14 -2.84217094e-14 7 6 14"}]]]])

(def chevron-right
  (update-in chevron-left [1 :style] assoc :transform "scale(-1)"))
(def chevron-down
  (update-in chevron-left [1 :style] assoc :transform "rotate(-90deg)"))
(def chevron-up
  (update-in chevron-left [1 :style] assoc :transform "rotate(90deg)"))

(def close-x
  [:svg
   {:width "16px", :height "16px", :view-box "0 0 16 16", :preserve-aspect-ratio "xMidYMid meet"}
   [:defs {}]
   [:g
    {:stroke "none", :stroke-width "1", :fill "none", :fill-rule "evenodd"}
    [:g
     {:transform "translate(-5.000000, -5.000000)", :fill "currentColor"}
     [:path
      {:d "M11.9975142,12.000001 L4,12.000001 L4,14.000001 L11.9975142,14.000001 L11.9975142,22 L13.9975142,22 L13.9975142,14.000001 L22,14.000001 L22,12.000001 L13.9975142,12.000001 L13.9975142,4 L11.9975142,4 L11.9975142,12.000001 Z",
       :transform "translate(13.000000, 13.000000) rotate(-225.000000) translate(-13.000000, -13.000000) "}]]]])

(def checkmark-thick [:svg
                      {:width "18px", :height "14px", :view-box "0 0 18 14", :preserve-aspect-ratio "xMidYMid meet"}
                      [:defs {}]
                      [:g
                       {:stroke "none", :stroke-width "1", :fill "none", :fill-rule "evenodd"}
                       [:g
                        {:transform "translate(-28.000000, -14.000000)", :stroke-width "3", :stroke "currentColor"}
                        [:g
                         {:transform "translate(29.000000, 15.000000)"}
                         [:polyline {:points "0 4.9278182 5.05921151 10.0349536 15 1.74971149e-13"}]]]]])
(def checkmark-thin [:svg
                     {:width "18px", :height "14px", :view-box "0 0 18 14", :preserve-aspect-ratio "xMidYMid meet"}
                     [:defs {}]
                     [:g
                      {:stroke "none", :stroke-width "1", :fill "none", :fill-rule "evenodd"}
                      [:g {:fill "currentColor"} [:polygon {:points "5.6 10.6 1.4 6.4 0 7.8 5.6 13.4 17.6 1.4 16.2 8.8817842e-16"}]]]])


(def triangle
  [:svg
   {:width "20px", :height "12px", :view-box "0 0 20 12", :preserve-aspect-ratio "xMidYMid meet"
    :style {:transform-origin "center top"}}
   [:defs {}]
   [:g
    {:stroke "none", :stroke-width "1", :fill "none", :fill-rule "evenodd"}
    [:polygon {:fill "currentColor", :points "10 0 20 12 0 12"}]]])

(def blank [:svg
            {:width "41px", :height "16px", :preserve-aspect-ratio "xMidYMid meet", :view-box "0 0 41 16"}])

(comment
  {:chevron/right [:svg
                   {:width "6px",
                    :height "13px",
                    :view-box "0 0 6 13",
                    :preserve-aspect-ratio "xMidYMid meet"}
                   [:defs {}]
                   [:g
                    {:stroke "none",
                     :stroke-width "1",
                     :fill "none",
                     :fill-rule "evenodd",
                     :stroke-linecap "square"}
                    [:g
                     {:transform "translate(-101.000000, -17.000000)",
                      :stroke "currentColor",
                      :stroke-width "1.5"}
                     [:g
                      {:transform "translate(102.000000, 18.000000)"}
                      [:polyline
                       {:transform
                        "translate(2.000000, 5.500000) rotate(-270.000000) translate(-2.000000, -5.500000) ",
                        :points "-3 6.89565687 1.94607051 4 7 7"}]]]]]})